import { Colors } from '@lightningjs/sdk';
import { Row } from '@lightningjs/ui-components';

export default class VODRow extends Row {
  static _template() {
    return {
      ...super._template(),
      lazyUpCount: 4,
      lazyUpCountBuffer: 4,
      Title: {
        text: {
          x: 0,
          y: 0,
          fontSize: 30,
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
          textColor: Colors('#fafafa').get(),
        },
        zIndex: 5,
      },
    };
  }

  _attach() {
    super._attach && super._attach();
    this.patch({
      Items: {
        y: 80,
        x: 20,
      },
    });
  }

  set title(val) {
    this.Title.text = val;
  }

  get title() {
    return this.Title.text.text;
  }

  get Title() {
    return this.tag('Title');
  }
}
